import React from 'react';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Table,
} from 'reactstrap';
import {parseDate} from '../../utils/Utilities';
import {DD_MM_YYYY_HH_MM_SS} from '../../utils/Global';
// import label from '../../message/Label'
import label from 'enqc-utilities/src/label/Label'

import PropTypes from "prop-types";
import BaseComponent from "../BaseComponent";


export default class UserStatusHistoryModal extends BaseComponent{

    constructor(props) {
        super(props);
        let user = this.props.user?this.props.user:{}
        let userStatuses = user.userStatuses?user.userStatuses:[]
        this.state ={
            user:user,
            userStatuses:userStatuses
        }
    }

    componentWillReceiveProps(props, nextContext) {
        if(props.showing){
            let user = props.user?props.user:{}
            let userStatuses = user.userStatuses?user.userStatuses:[]

            this.setState({
                user:user, userStatuses:userStatuses
            })
        }
    }


    render() {
        let {user, userStatuses} = this.state

        return (
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    style={{minWidth:'90%'}}
                    size="xl"
                    centered={true}
                    isOpen={this.props.showing}
                    backdrop={true}>
                    {super.render()}
                    <ModalHeader>
                        {label.StatusHistory}
                    </ModalHeader>
                    <ModalBody>
                        {this.renderUserStatuses()}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={e=>{
                                e.preventDefault()
                                this.props.onClose()
                            }}>
                            {label.Close}
                        </Button>
                    </ModalFooter>
                </Modal>

            </>
        )
    }

    renderUserStatuses = () =>{
        return (
            <Row key={2}>
                <Col>
                    <Card>
                        <CardHeader>
                            <strong>{label.UserStatus}</strong>
                        </CardHeader>
                        <CardBody>
                            {this.renderUserStatusesTable()}
                        </CardBody>

                    </Card>
                </Col>
            </Row>
        )
    }


    renderUserStatusesTable = () =>{
        let {userStatuses} = this.state
        return (
            <Card>
                <CardBody>
                    <Table responsive hover>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>{label.Status}</th>
                            <th>{label.Reason}</th>
                            <th>{label.PerformedBy}</th>
                            <th>{label.Created}</th>
                            <th>{label.Updated}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                           userStatuses.map((item, index)=>(
                                <tr key={item.id}>
                                    <th scope="row">{(++index)}</th>
                                    <td>{item.name}</td>
                                    <td>{item.reason}</td>
                                    <td>{item.performer?item.performer.fullname:"-"}</td>
                                    <td>{parseDate(item.created, DD_MM_YYYY_HH_MM_SS)}</td>
                                    <td>{parseDate(item.updated, DD_MM_YYYY_HH_MM_SS)}</td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
        )
    }


}

UserStatusHistoryModal.propTypes = {
    showing:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    user:PropTypes.object.isRequired
}
